import { Injectable } from '@angular/core';
import { ClientAddress, Contractor, SalesDocumentClient } from '@icc/b2b/shared';

@Injectable({
    providedIn: 'root',
})
export class ClientService {

    static convertToDocumentClient(contractor: Contractor, addresses?: {
        id: number;
        deliveryId: number;
        delivery: ClientAddress;
    }, existingClient?: SalesDocumentClient): SalesDocumentClient {

        let invoiceId = null;
        let invoice = null;

        if(existingClient?.invoice){
            invoiceId = existingClient?.invoice?.id ?? existingClient?.invoiceId;
            invoice = existingClient?.invoice;
        }else if(contractor?.registry){
            invoiceId = contractor?.registry?.id;
            invoice = contractor.registry;
        }else if(contractor?.delivery){
            invoiceId = contractor?.delivery?.id;
            invoice = contractor.delivery;
        }

        return {
            id: contractor.id,
            isCompany: contractor.isCompany,
            firstName: contractor.person?.firstName,
            lastName: contractor.person?.lastName,
            reference: contractor.reference || '',
            email: contractor.email,
            phoneNumber:  contractor?.phone,
            deliveryEmail: contractor?.deliveryEmail,
            deliveryPhone: contractor?.deliveryPhone,
            invoiceEmail: contractor?.invoiceEmail,
            invoicePhone: contractor?.invoicePhone,
            companyName: contractor.company?.name,
            companyVatNr: contractor.company?.vatNr,
            companyVatNrEu: contractor.company?.vatNrEu,
            deliveryId: addresses?.deliveryId ?? contractor.delivery?.id,
            delivery: addresses?.delivery ?? contractor.delivery,
            billingDelivery: existingClient?.billingDelivery ?? contractor.contact ?? null,
            billingDeliveryId: existingClient?.billingDeliveryId ?? contractor.contact?.id,
            invoiceFromDelivery: (addresses?.deliveryId ?? (addresses?.delivery ?? contractor.delivery)?.id) === invoice?.id ?? true,
            invoiceId,
            invoice,
            otherContact: existingClient?.otherContact || ((addresses?.deliveryId ?? contractor.delivery?.id) !== (existingClient?.billingDeliveryId ?? contractor.contact?.id)),
        };
    }

    static convertSellerToDocumentClient(seller, contractor?: Contractor, existingClient?: SalesDocumentClient): SalesDocumentClient {
        const invoices = seller?.company?.addresses?.filter(address => Array.isArray(address?.contactFunctions) && address?.contactFunctions?.some(el => el === 'registry'));
        let invoice = invoices[0];
        if (existingClient?.invoice) {
            invoice = existingClient?.invoice;
        } else if (contractor?.registry?.id) {
            invoice = invoices.find(el => el.id === contractor.registry.id);
        }
        const invoiceId = invoice?.id ?? null;

        return {
            id: seller.id,
            isCompany: true,
            firstName: seller.person?.first_name,
            lastName: seller.person?.last_name,
            reference: seller.person?.reference_name || '',
            email: seller?.person?.email_addresses?.find(el => el.contact_function_id === 'contact')?.email ?? seller?.person?.email,
            phoneNumber:  seller?.person?.phone_numbers?.find(el => el.contact_function_id === 'contact')?.phone_number ?? seller?.person?.phone_number,
            deliveryEmail: null,
            deliveryPhone: null,
            invoiceEmail: seller?.company?.emails?.find(el => el.contactFunction === 'registry')?.email,
            invoicePhone: seller?.company?.phoneNumbers?.find(el => el.contactFunction === 'registry')?.phoneNumber,
            companyName: seller.company?.name,
            companyVatNr: seller.company?.vatNr,
            companyVatNrEu: seller.company?.vatNrEu,
            deliveryId: seller?.delivery?.id ?? null,
            delivery: seller?.delivery ?? invoice,
            billingDelivery: existingClient?.billingDelivery ?? contractor?.contact ?? null,
            billingDeliveryId: existingClient?.billingDeliveryId ?? contractor?.contact?.id ?? null,
            invoiceFromDelivery: !seller?.delivery?.id || seller?.delivery?.id === invoice?.id,
            invoiceId,
            invoice,
            otherContact: ((seller.delivery ?? invoice)?.id !== (existingClient?.billingDeliveryId ?? contractor?.contact?.id)) || false,
        };
    }
}
